import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import Service_Vid from "../video/Service_Vid.mp4";
import "./Services.css";
import qa from "../image/qa.jpg";
import clinicalData from "../image/clinicalData.jpg";
import due from "../image/due.jpg";
import hmis from "../image/hmis.jpg";
import hr from "../image/hr.jpg";
import medicalEquipment from "../image/medicalEquipment.jpg";
import nabh from "../image/nabh.jpg";
import medicalValue from "../image/medicalValue.jpg";
import JoinUs from "./JoinUs";

function Services() {
  const [hasVideoSection, setHasVideoSection] = useState(false);

  useEffect(() => {
    setHasVideoSection(
      !!document.querySelector(".dashboard-background .video-container")
    );
  }, []);
  return (
    <div
      className="dashboard-background"
      style={{
        padding: "0px",
        overflow: "hidden",
      }}
    >
      <div
        className="grid align-items-stretch"
        style={{ padding: hasVideoSection ? "20px" : "0px" }}
      >
        {/* Left Section - Information (Full width when video is hidden) */}
        <div className="col-12 lg:col-8">
          <Card className="p-4 h-full">
            <h2 className="text-primary text-2xl lg:text-3xl">Our Services</h2>
            <p className="text-sm lg:text-base">
              We offer a comprehensive range of healthcare solutions, ensuring
              excellence in medical operations and patient care.
            </p>

            <Divider />

            <ul className="list-none p-0 text-sm lg:text-base">
              <li>
                <strong>NABH/NABC Accreditation:</strong> Support in achieving
                and maintaining national standards in healthcare quality and
                patient safety.
              </li>
              <li>
                <strong>Due Diligence:</strong> Detailed evaluations to ensure
                regulatory compliance and operational excellence.
              </li>
              <li>
                <strong>Quality Assurance:</strong> Ongoing assessments and
                improvements in healthcare processes to guarantee high
                standards.
              </li>
              <li>
                <strong>HR Recruitment:</strong> Specialized recruitment
                solutions to find the best healthcare professionals for your
                organization.
              </li>
              <li>
                <strong>Medical Value Tourism:</strong> Assisting international
                patients in accessing high-quality healthcare services across
                borders.
              </li>
              <li>
                <strong>TPA Insurance:</strong> Management and facilitation of
                third-party healthcare insurance processes.
              </li>
              <li>
                <strong>Clinical Data Management (CDM):</strong> Robust data
                solutions for accurate, secure, and efficient management of
                clinical data.
              </li>
              <li>
                <strong>Hospital Management Information System (HMIS):</strong>{" "}
                Customizable solutions to streamline hospital operations and
                improve patient care.
              </li>
              <li>
                <strong>Biomedical Equipment:</strong> Provision and maintenance
                of advanced biomedical equipment for reliable healthcare
                delivery.
              </li>
            </ul>
          </Card>
        </div>

        {/* Right Section - Video (Only visible at 1000px or above) */}
        <div className="col-12 lg:col-4 video-section">
          <Card className="p-0 h-full">
            <div className="video-container">
              <video
                autoPlay
                loop
                muted
                onLoadedMetadata={(e) => (e.target.playbackRate = 1)}
                className="full-width-video"
              >
                <source src={Service_Vid} type="video/mp4" />
              </video>
            </div>
          </Card>
        </div>
      </div>

      <div className="information-section">
        <div className="grid p-5">
          {[
            { src: qa, title: "Quality Assurance" },
            { src: nabh, title: "NABH Accreditation" },
            { src: hmis, title: "HMIS" },
            { src: due, title: "Due Diligence" },
            { src: clinicalData, title: "Clinical Data Management" },
            { src: medicalValue, title: "Medical Value Travel" },
            { src: medicalEquipment, title: "Biomedical Equipment" },
            { src: hr, title: "HR Recruitment" },
          ].map((service, index) => (
            <div
              key={index}
              className="col-12 md:col-3 flex flex-column align-items-center text-center"
            >
              <div className="service-card">
                <img
                  src={service.src}
                  alt={service.title}
                  className="service-image border-round shadow-3"
                  loading="lazy"
                />
                <p className="service-title">{service.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <JoinUs />
    </div>
  );
}

export default Services;
